<template>
  <div>
    <svg
      version="1.1"
      id="Icons"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 32 32"
      style="enable-background:new 0 0 32 32;"
      xml:space="preserve"
    >
      <line class="st0" x1="3" y1="11" x2="16" y2="11" />
      <line class="st0" x1="16" y1="11" x2="29" y2="11" />
      <line class="st0" x1="16" y1="2" x2="16" y2="30" />
      <polyline class="st0" points="16,27 29,27 29,5 16,5 " />
      <polyline class="st0" points="16,5 3,5 3,27 16,27 " />
      <path class="st0" d="M22.5,19H20v-3h2.5c0.8,0,1.5,0.7,1.5,1.5v0C24,18.3,23.3,19,22.5,19z" />
      <path class="st0" d="M23.5,22H20v-3h3.5c0.8,0,1.5,0.7,1.5,1.5v0C25,21.3,24.3,22,23.5,22z" />
      <polyline class="st0" points="6,22 9.5,16 13,22 " />
      <line class="st0" x1="7" y1="21" x2="12" y2="21" />
      <line class="st0" x1="7" y1="8" x2="7" y2="8" />
      <line class="st0" x1="10" y1="8" x2="10" y2="8" />
      <line class="st0" x1="13" y1="8" x2="13" y2="8" />
    </svg>
  </div>
</template>

<script>
export default {};
</script>

<style scoped type="text/css">
.st0 {
  fill: none;
  stroke: #000000;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-miterlimit: 10;
}
.st1 {
  fill: none;
  stroke: #000000;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.st2 {
  fill: none;
  stroke: #000000;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 5.2066, 0;
}
</style>
